var render = function render(){var _vm=this,_c=_vm._self._c;return _c('textarea',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.localModel),expression:"localModel"}],staticClass:"base-textarea",domProps:{"value":(_vm.localModel)},on:{"input":function($event){if($event.target.composing)return;_vm.localModel=$event.target.value}}},'textarea',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }